<nav class="navbar navbar-expand-lg cus-nav-bar navbar-fixed-top flex">
    <span class="hamburger" (click)="onToggleSideNav()" *ngIf="!isSideBarOpen">
        ☰
    </span>
    <div class="hamburger" (click)="onToggleSideNav()" *ngIf="isSideBarOpen">
        X
    </div>
    <span class="cine-awards-nav-header" [ngClass]="{'header_container': isArchive}">cinejoy</span>
    <span>
        <div class="form-floating" fxHide.xs fxHide.sm *ngIf="isArchive">
            <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                aria-label="Floating label select example" (change)="onChangeVersion($event)" style="width: 200px;height: 55px;">
                <option value="">Choose Award Version</option>
                <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}</option>
            </select>
            <label for="floatingSelect" class="value-label">Choose Version</label>
        </div>
    </span>
</nav>
<app-sidebar [secNavOpen]="true" [showHeader]="false" *ngIf="isSideBarOpen"></app-sidebar>

<div class="main-cotainer">
    <div class="mt-5" fxShow.xs fxShow.sm fxHide.md fxHide.lg fxHide.xl *ngIf="isArchive">
        <div class="form-floating">
            <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                aria-label="Floating label select example" (change)="onChangeVersion($event)">
                <option value="">Choose Award Version</option>
                <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}</option>
            </select>
            <label for="floatingSelect" class="value-label">Choose Version</label>
        </div>
    </div>

    <div class="banner mt-5">
        <div fxLayout="row wrap" fxLayout.sm="column wrap" fxLayout.md="row wrap" fxLayout.xs="column wrap" fxHide.xs>
            <div fxLayout="column wrap" fxFlex="50" *ngFor="let item of awardsList.awardsBanner">
                <div class="card">
                    <div class="banner-image"
                        [ngStyle]="{'background-image': 'url(' + item.thumbnail + ')' , 'background-repeat': 'no-repeat','background-size': 'cover' }"
                        class="banner-image"></div>
                    <div>
                        <div class="award-banner-badge">
                            <img src="../../../../../assets/images/vector1.png" class="badge-image">
                            <div class="awards-text">
                                <div class="award-name">Audience Award</div>
                                <span class="cine-awards">cinejoy</span>
                                <div class="award-category"> Comedy&nbsp;</div>
                            </div>
                            <img src="../../../../../assets/images/vector2.png" class="badge-image">
                        </div>
                        <div class="badge-container">
                            <div class="sub-text-award" [title]="item?.award">{{item?.award}}</div>
                            <div class="item-text-award" [title]="item?.award_message1">{{item?.award_message1}}</div>
                            <div class="row">
                                <button type="button" class="btn btn-light all-badge-btn ml-3"
                                    (click)="goToLink(item.movie_link, item.type ? item.type : null)">More Info</button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="all-banners-custom-mobile mt-6 mb-2 " fxHide.lg fxHide.md >
        <div fxLayout="column" class="g-2 ml-2">
            <div fxLayout="row wrap" class="mt-3 awardess-col justify-content-center" *ngFor="let item of awardsList.awardsBanner">
                <div class="card" style="width: 95vw;display: flex;flex-direction: row;"
                    (click)="goToLink(item.movie_link, item.type ? item.type : null)">
                    <img class="card-img-top" [src]="item.mobile_thumbnail" alt="Card image cap" style="width: 130px;
                    height: 120px;
                    min-width: 130px;
                    max-width: 130px;">
                    <div class="card-body">
                        <p class="premiere" [title]="item.award">{{item.award}}</p>
                        <h5 class="premierePara" [title]="item.award_message1">{{item.award_message1}}</h5>

                    </div>
                </div>
            </div>

        </div>
        <!-- <div>
            <owl-carousel-o [options]="customOptions" style="width: 90%;">
                <ng-container *ngFor="let item of awardsList.recentWinners">
                    <ng-template carouselSlide [id]="item.id">
                        <div class="card award-winners-card top-awards" (click)="goToLink(item.movie_link)">
                            <img class="card-img-top" [src]="item.thumbnail" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title mb-0" [title]="item.winner">{{item.winner}}</h5>
                                <p class="card-text" [title]="item.award">{{item.award}}</p>
                                <button type="button" class="btn btn-light">More Info</button>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>

            </owl-carousel-o>
        </div> -->
    </div>
</div>
<div class="static-container">
    <div fxLayout="row" class="audiance-header">Vote now for the Audience Choice Awards!</div>
    <div fxLayout="row" fxLayout.sm="column wrap" fxLayout.md="row wrap" fxLayout.xs="column wrap">
        <div fxLayout="column wrap" fxFlex="42" fxFlex.md="33" class="audience-box">
            <div><img src="../../../../../assets/images/glasses.png"></div>
            <div class="cus-icon-label">Watch</div>
            <div class="aud-sub-text">Enjoy the latest features and films through Premieres and Showcase.</div>

        </div>
        <div fxLayout="column wrap" fxFlex="42" fxFlex.md="33" class="audience-box">
            <div><img src="../../../../../assets/images/heart.png"></div>
            <div class="cus-icon-label">Rate</div>
            <div class="aud-sub-text">Rate the features you enjoy and leave reviews for others to see.</div>
        </div>
        <div fxLayout="column wrap" fxFlex="42" fxFlex.md="33" class="audience-box">
            <div><img src="../../../../../assets/images/cup.png"></div>
            <div class="cus-icon-label">Award</div>
            <div class="aud-sub-text">Features with the best ratings will receive Audience Choice Awards.</div>

        </div>
    </div>
    <div class="row showacase-navigate">
        <button type="button" class="btn btn-light" [routerLink]="['/cinejoy/showcase']">Go to Showcase</button>

    </div>
</div>
<div class="recents-container">

    <div class="recents-banner" fxHide.xs>
        <div class="recent-award-header">Recent Winners</div>

        <div fxLayout="row wrap">
            <div fxLayout="column wrap" fxFlex="25" fxFlex.md="25" fxFlex.sm="50"
                *ngFor="let item of awardsList.recentWinners">
                <div class="card award-winners-card" (click)="goToLink(item.movie_link)">
                    <img class="card-img-top" [src]="item.thumbnail" alt="Card image cap">
                    <div class="card-body">
                        <h5 class="card-title mb-0" [title]="item.winner">{{item.winner}}</h5>
                        <p class="card-text" [title]="item.award">{{item.award}}</p>
                        <button type="button" class="btn btn-light">More Info</button>

                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row wrap" class="all-awardees">
            <button type="button" class="btn btn-light all-awardees-btn" (click)="navigateAllAwards()">See all the
                awardees</button>
        </div>
    </div>
    <div class="all-awardees-custom-mobile mb-4" fxHide.lg fxHide.md >
        <div class="row g-2 ml-2">
            <h1 class="awards-title">Recent Winners</h1>
            <div class="col mt-3 awardess-col" *ngFor="let item of awardsList.recentWinners">
                <div class="card" style="width: 95vw;display: flex;flex-direction: row;">
                    <img class="card-img-top" [src]="item.mobile_thumbnail" alt="Card image cap" style="width: 130px;
                    height: 120px;
                    min-width: 130px;
                    max-width: 130px;">
                    <div class="card-body" (click)="goToLink(item.movie_link)">
                        <p class="card-text" [title]="item.winner">{{item.winner}}</p>
                        <h5 class="card-title" [title]="item.award">{{item.award}}</h5>

                    </div>
                </div>
            </div>
        </div>
        <div class="row all-awardees">
            <button type="button" class="btn btn-light all-awardees-btn" (click)="navigateAllAwards()">See all the
                awardees</button>
        </div>
    </div>
</div>